/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

export const BloqueBTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueBCollapsed,
  setBloqueBCollapsed,
  hardwareMensualesCombinados,
  ingresosHardwareMensual,
  monthsToShow,
  openHardwareIngresosModal,
  formatCurrency,
  formatPercentage,
  porcentajeSobreFacturacion,
  ytdIngresosHardware,
  compraHardwareMensual,
  instalacionMensual,
  materialesMensual,
  otrosCostosMensual,
  openHardwareFlexModal,
  onDetalleFactura,
  ytdCompraHardware,
  ytdInstalacion,
  ytdMateriales,
  ytdOtrosCostosHardware,
  ytdMargenHardware,
  margenPorcentaje,
  margenHardwareMensualUSD,
  ingresosHardwareMensualUSD,
  compraHardwareMensualUSD,
  instalacionMensualUSD,
  materialesMensualUSD,
  otrosCostosMensualUSD,
  pais,
  verEnDolares,
  // FASE 3 PASO 4c: fuente única Chile+Perú (`construirFilasER`) para las sub-filas de Bloque B
  // en modo combinado — antes esta sección entera se ocultaba (`!modoCombinado`), igual que
  // RRHH/13 cuentas antes de E2b (hallazgo E1 §3a, nunca cerrado para B/D).
  filasCombinado = null,
}) => {
  // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": bottom-up ya construido en
  // index.js (`vXxxUSD`); Perú sigue con el camino de siempre (10.265/10.267). Mismo helper
  // que el resto de los bloques de este mismo punto.
  const yaEnUSDChile = pais === "Chile" && verEnDolares;
  const vUSD = (valorChileUSD, valorPeso) => (yaEnUSDChile ? valorChileUSD || Array(12).fill(0) : valorPeso);
  const ingresoMostrado = modoCombinado
    ? hardwareMensualesCombinados
    : vUSD(ingresosHardwareMensualUSD, ingresosHardwareMensual);
  // FASE 3 PASO 4c: en combinado, las sub-filas leen `filasCombinado` (fuente única) en vez
  // del valor NO combinado de la sesión — mismo patrón que ya usan A y C para su detalle.
  const compraMostrado = modoCombinado
    ? filasCombinado["B - Hardware / Compra hardware"].usd
    : vUSD(compraHardwareMensualUSD, compraHardwareMensual);
  const instalacionMostrado = modoCombinado
    ? filasCombinado["B - Hardware / Instalación"].usd
    : vUSD(instalacionMensualUSD, instalacionMensual);
  const materialesMostrado = modoCombinado
    ? filasCombinado["B - Hardware / Materiales"].usd
    : vUSD(materialesMensualUSD, materialesMensual);
  const otrosMostrado = modoCombinado
    ? filasCombinado["B - Hardware / Otros costos"].usd
    : vUSD(otrosCostosMensualUSD, otrosCostosMensual);
  return (
    <>
      {/* === BLOQUE B - Hardware === */}
      <tr
        className={styles.sectionHeader}
        onClick={(e) => {
          e.stopPropagation();
          setBloqueBCollapsed(!bloqueBCollapsed);
        }}
        style={{ cursor: "pointer", userSelect: "none" }}
      >
        <td className={styles.conceptCell}>B - Hardware {!verUltimos12Meses && bloqueBCollapsed ? ">" : ""}</td>
        {ingresoMostrado.map((val, i) => (
          <td
            key={i}
            className="text-end"
            style={{
              cursor: !modoCombinado && !verUltimos12Meses && i < monthsToShow && val > 0 ? "pointer" : "default",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!modoCombinado && !verUltimos12Meses && i < monthsToShow && val > 0) openHardwareIngresosModal(i);
            }}
          >
            {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
          </td>
        ))}
        <td className={styles.totalCell}>
          {formatCurrency(
            ingresoMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
            null,
            modoCombinado || yaEnUSDChile ? null : ingresosHardwareMensual,
            modoCombinado || yaEnUSDChile
          )}{" "}
          |{" "}
          {porcentajeSobreFacturacion(
            modoCombinado
              ? hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
              : ytdIngresosHardware
          )}
        </td>
      </tr>

      {!bloqueBCollapsed && (
        <>
          {/* 1. Compra hardware */}
          <tr>
            <td className={styles.conceptCell}>Compra hardware</td>
            {compraMostrado.map((val, i) => (
              <td
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  if (modoCombinado || i >= monthsToShow) return;
                  // v2: si la celda sale de facturas, abre su detalle.
                  if (onDetalleFactura?.disponible(i)) {
                    onDetalleFactura.abrir("hardware", "Compra hardware", i);
                    return;
                  }
                  openHardwareFlexModal(i);
                }}
                style={{ cursor: !modoCombinado && i < monthsToShow ? "pointer" : "default" }}
              >
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                compraMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : compraHardwareMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              | {ytdIngresosHardware > 0 ? formatPercentage((ytdCompraHardware / ytdIngresosHardware) * 100) : "0%"}
            </td>
          </tr>

          {/* 2. Instalación */}
          <tr>
            <td className={styles.conceptCell}>Instalación</td>
            {instalacionMostrado.map((val, i) => (
              <td key={i} className="text-end">
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                instalacionMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : instalacionMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              | {ytdIngresosHardware > 0 ? formatPercentage((ytdInstalacion / ytdIngresosHardware) * 100) : "0%"}
            </td>
          </tr>

          {/* 3. Materiales */}
          <tr>
            <td className={styles.conceptCell}>Materiales</td>
            {materialesMostrado.map((val, i) => (
              <td key={i} className="text-end">
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                materialesMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : materialesMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              | {ytdIngresosHardware > 0 ? formatPercentage((ytdMateriales / ytdIngresosHardware) * 100) : "0%"}
            </td>
          </tr>

          {/* 4. Otros costos */}
          <tr>
            <td className={styles.conceptCell}>Otros costos</td>
            {otrosMostrado.map((val, i) => (
              <td key={i} className="text-end">
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                otrosMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : otrosCostosMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              |{" "}
              {ytdIngresosHardware > 0 ? formatPercentage((ytdOtrosCostosHardware / ytdIngresosHardware) * 100) : "0%"}
            </td>
          </tr>

          {/* Contribución B — en combinado lee `filasCombinado` (fuente única, FASE 3 PASO 4c);
            Chile + "Ver en US$" usa `margenHardwareMensualUSD` (bottom-up, ya construido en
            index.js); Perú sigue con el camino de siempre (10.265/10.267). El % siempre se
            mide en pesos. */}
          {modoCombinado ? (
            <tr className={styles.marginRow}>
              <td className={styles.conceptCellMargen}>Contribución</td>
              {filasCombinado["B - Hardware / Contribución"].usd.map((margenUsd, i) => (
                <td key={i} className="text-end">
                  <div className={margenUsd < 0 ? styles.marginNegative : ""}>
                    {i < monthsToShow ? formatCurrency(margenUsd, i, null, true) : "-"}
                  </div>
                </td>
              ))}
              <td className={styles.totalCell}>
                {(() => {
                  const totalComb = filasCombinado["B - Hardware / Contribución"].usd
                    .slice(0, monthsToShow)
                    .reduce((a, b) => a + (b || 0), 0);
                  return (
                    <div className={totalComb < 0 ? styles.marginNegative : ""}>
                      {formatCurrency(totalComb, null, null, true)} |{" "}
                      {margenPorcentaje(
                        totalComb,
                        hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
                      )}
                    </div>
                  );
                })()}
              </td>
            </tr>
          ) : pais === "Chile" && verEnDolares ? (
            <tr className={styles.marginRow}>
              <td className={styles.conceptCellMargen}>Contribución</td>
              {(margenHardwareMensualUSD || Array(12).fill(0)).map((margenUsd, i) => (
                <td key={i} className="text-end">
                  <div className={margenUsd < 0 ? styles.marginNegative : ""}>
                    {i < monthsToShow ? formatCurrency(margenUsd, i, null, true) : "-"}
                  </div>
                </td>
              ))}
              <td className={styles.totalCell}>
                <div className={ytdMargenHardware < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(
                    (margenHardwareMensualUSD || Array(12).fill(0))
                      .slice(0, monthsToShow)
                      .reduce((a, b) => a + (b || 0), 0),
                    null,
                    null,
                    true
                  )}{" "}
                  | {margenPorcentaje(ytdMargenHardware, ytdIngresosHardware)}
                </div>
              </td>
            </tr>
          ) : (
            <tr className={styles.marginRow}>
              <td className={styles.conceptCellMargen}>Contribución</td>
              {ingresosHardwareMensual.map((ing, i) => {
                const totalCostos =
                  compraHardwareMensual[i] + instalacionMensual[i] + materialesMensual[i] + otrosCostosMensual[i];
                const margen = ing - totalCostos;
                return (
                  <td key={i} className="text-end">
                    <div className={margen < 0 ? styles.marginNegative : ""}>
                      {i < monthsToShow ? formatCurrency(margen, i) : "-"}
                    </div>
                  </td>
                );
              })}
              <td className={styles.totalCell}>
                <div className={ytdMargenHardware < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(
                    ytdMargenHardware,
                    null,
                    ingresosHardwareMensual.map(
                      (ing, i) =>
                        ing -
                        compraHardwareMensual[i] -
                        instalacionMensual[i] -
                        materialesMensual[i] -
                        otrosCostosMensual[i]
                    )
                  )}{" "}
                  | {margenPorcentaje(ytdMargenHardware, ytdIngresosHardware)}
                </div>
              </td>
            </tr>
          )}
        </>
      )}
    </>
  );
};
